import { type ReactNode } from 'react';
import { type ComponentCreateRequestStatusCode } from '@gql/graphql';
import { StatusIcon } from '@pages/notification-components/components/StatusIcon/StatusIcon';

export interface StatusCellProps {
    id: string;
    status: ComponentCreateRequestStatusCode;
}

export function StatusCell({ id, status }: StatusCellProps): ReactNode {
    return <StatusIcon id={id} status={status} />;
}
